// extracted by mini-css-extract-plugin
export default {"buttons":"Channel_buttons__51xJF"};